import { render, staticRenderFns } from "./splitLine.vue?vue&type=template&id=131ca265&scoped=true"
import script from "./splitLine.vue?vue&type=script&lang=js"
export * from "./splitLine.vue?vue&type=script&lang=js"
import style0 from "./splitLine.vue?vue&type=style&index=0&id=131ca265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ca265",
  null
  
)

export default component.exports